// extracted by mini-css-extract-plugin
export default {"pagination":"current-location_pagination__Hzqn+","page-link":"current-location_page-link__BTOCm","btns":"current-location_btns__5WhaP"};